import React, { useState } from "react";
import { ChevronRight, ChevronDown } from "lucide-react";
import css from "./style";

const NestedDataViewer = ({ data }) => {
	return (
		<div className={css.nestedDataContainer}>
			{Object.entries(data).map(([key, value]) => (
				<NestedItem key={key} name={key} data={value} />
			))}
		</div>
	);
};

const NestedItem = ({ name, data }) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const toggleExpand = () => setIsExpanded(!isExpanded);
	// Check if there's only one type
	const typeEntries = Object.entries(data.types || {});
	const hasSingleType = typeEntries.length === 1;
	const singleType = hasSingleType ? typeEntries[0][0] : null;
	const isNested = data.isNested;

	return (
		<div className={css.nestedItem}>
			<div className={css.itemHeader} onClick={toggleExpand} style={{ cursor: "pointer" }}>
				<span className={css.expandIcon}>
					{isExpanded ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
				</span>
				<span className={css.itemName}>{name}</span>
				{data.totalCount && (
					<span className={css.totalCount}>
						({data.totalCount} {data.totalCount === 1 ? "item" : "items"})
					</span>
				)}
				{hasSingleType && !isExpanded && <span className={css.singleTypeIndicator}>{singleType}</span>}
			</div>

			{isExpanded && (
				<div className={css.itemContent}>
					{isNested ? (
						// Render nested fields
						Object.entries(data.fields).map(([key, value]) => (
							<NestedItem key={key} name={key} data={value} />
						))
					) : (
						// Render type information
						<div>
							{typeEntries.map(([typeName, typeData]) => (
								<div key={typeName} className={css.typeItem}>
									<span className={css.typeName}>{typeName}:</span>
									<span>
										{typeData.count} {typeData.count === 1 ? "item" : "items"}
									</span>
									<span className={css.typePercentage}>({typeData.percentage}%)</span>
								</div>
							))}
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default NestedDataViewer;
